import { render, staticRenderFns } from "./bidding_company.vue?vue&type=template&id=4782b52a&"
import script from "./bidding_company.vue?vue&type=script&lang=js&"
export * from "./bidding_company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports